import { styled } from '@nykaa/ui-components';

export const GradientTextContainer = styled.span<{
  bgGradient: string[];
  degree: number;
}>`
  background: linear-gradient(${(props) => props.degree}deg, ${(props) => props.bgGradient.join(', ')});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* Inherit all typography properties from parent */
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  text-decoration: inherit;
  
  /* Apply gradient and typography to all child elements */
  * {
    background: linear-gradient(${(props) => props.degree}deg, ${(props) => props.bgGradient.join(', ')}) !important;
    -webkit-background-clip: text !important;
    background-clip: text !important;
    color: transparent !important;
    -webkit-text-fill-color: transparent !important;
    
    /* Ensure child elements inherit typography */
    font-family: inherit !important;
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    letter-spacing: inherit !important;
    text-transform: inherit !important;
    text-decoration: inherit !important;
  }
`;